export default __webpack_public_path__ + "static/media/sodibat.db529c01.png";